module.exports = __webpack_public_path__ + "img/AipromptWords.768015f6.gif";